/**
 * Feedback API Service
 * Handles API calls for message feedback submission
 */

import { baseApi } from 'utils/apiUtil';
import { httpM } from 'utils/httpUtil';

export interface FeedbackPayload {
  messageId: string;
  feedback: 'positive' | 'negative' | null;
  timestamp: string;
  userId?: string;
  sessionId: string;
  userQuestion: string;
  aiAnswer: string;
  benefitGuideId?: string;
  employerId?: string;
  conversationContext?: {
    currentSession?: any;
  };
}

export interface FeedbackResponse {
  success: boolean;
  message?: string;
  feedbackId?: string;
}

export class FeedbackApiService {
  private feedbackURL: string;

  constructor() {
    this.feedbackURL = `${baseApi}/v2/assistant/feedback`;
  }

  /**
   * Submit feedback for a message
   * @param {FeedbackPayload} payload - The feedback data including messageId, feedback type, timestamp, and optional user info
   */
  async submitFeedback(payload: FeedbackPayload): Promise<FeedbackResponse> {
    try {
      const response = await httpM.post(this.feedbackURL, payload);
      return {
        success: true,
        ...response,
      };
    } catch (error) {
      console.error('Failed to submit feedback:', error);
      return {
        success: false,
        message:
          error instanceof Error ? error.message : 'Unknown error occurred',
      };
    }
  }
}

export const feedbackApiService = new FeedbackApiService();
